export default {
    name: "work-plan",
    component: () => import(/* auth-router-module */ '@/layouts/PrincipalLayout.vue'),
    children: [
        {
            path: "",
            name: "work-plan-index",
            meta: {
                breadcrumbs: [],
                title: "Plan de fortalecimiento"
            },
            component: () => import('@/modules/work-plans/views/Index.vue')
        },
        {
            path: ":id",
            name: "work-plan-detail",
            meta: {
                breadcrumbs: [],
                title: "Plan de fortalecimiento"
            },
            component: () => import('@/modules/work-plans/views/Detail.vue')
        }
    ]
}